import * as React from "react";
import { pointsCreator } from "../EditIgnoreZones/EditIgnoreZonesUtils/pointsCreatorLarger";
import { useNewIgnoreZonesStore } from "./newIgnoreZonesStore/newIgnoreZonesStore";
import { assignmentsToPreviewZones } from "./utils/coordinateTransforms";

export const IgnoreZonePreview = () => {
  const previewUrl = useNewIgnoreZonesStore((s) => s.previewUrl);
  const assignments = useNewIgnoreZonesStore((s) => s.assignments);
  const adjustedDimensions = useNewIgnoreZonesStore((s) => s.adjustedDimensions);
  const dimensions = useNewIgnoreZonesStore((s) => s.dimensions);

  const previewZones = React.useMemo(
    () => assignmentsToPreviewZones(assignments),
    [assignments]
  );

  if (!previewUrl) {
    return null;
  }

  return (
    <div className="relative">
      <img
        src={previewUrl}
        style={{
          width: `${adjustedDimensions.x}px`,
          height: `${adjustedDimensions.y}px`,
        }}
        alt="Camera preview"
      />
      {previewZones.map((zone) => (
        <div className="absolute top-0 left-0" key={zone.label}>
          {zone.coordinates.map((polygon, index) => (
            <svg
              className="absolute top-0 left-0"
              key={`${zone.label}-${index}`}
              style={{
                width: `${adjustedDimensions.x}px`,
                height: `${adjustedDimensions.y}px`,
              }}
            >
              {dimensions && (
                <polygon
                  points={pointsCreator(
                    polygon,
                    adjustedDimensions.y,
                    adjustedDimensions.x
                  )}
                  stroke={zone.line_color}
                  strokeWidth="5"
                  fill={zone.line_color}
                  fillOpacity="50%"
                />
              )}
            </svg>
          ))}
        </div>
      ))}
    </div>
  );
};
